import { render, staticRenderFns } from "./TeacherList.vue?vue&type=template&id=4ab485fa"
import script from "./TeacherList.vue?vue&type=script&lang=js"
export * from "./TeacherList.vue?vue&type=script&lang=js"
import style0 from "./TeacherList.vue?vue&type=style&index=0&id=4ab485fa&prod&lang=scss"
import style1 from "./TeacherList.vue?vue&type=style&index=1&id=4ab485fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports